import React, { useEffect, useState } from "react";
import api, { API } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Award, Download, QrCode } from "lucide-react";

export default function Certificates() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/certificates/me").then((r) => setItems(r.data)); }, []);
  return (
    <div className="space-y-8" data-testid="certificates-page">
      <header>
        <div className="eyebrow">Meus certificados</div>
        <h1 className="font-display text-3xl md:text-4xl font-extrabold tracking-tight mt-1">Certificados emitidos</h1>
        <p className="text-slate-600 mt-2 text-sm">Baixe seus certificados ou compartilhe via QR Code para validação pública.</p>
      </header>
      {items.length === 0 ? (
        <Card><CardContent className="p-10 text-center text-slate-600">
          <Award className="w-10 h-10 mx-auto text-slate-400 mb-3" />
          Você ainda não possui certificados. Conclua um curso e a aprovação na avaliação gera o certificado automaticamente.
        </CardContent></Card>
      ) : (
        <div className="grid md:grid-cols-2 gap-5" data-testid="certificates-grid">
          {items.map((c) => (
            <Card key={c.id} className="border-[var(--unigr-border)]">
              <CardContent className="p-6">
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <div className="eyebrow">UNIGR · Certificado</div>
                    <div className="font-display font-bold text-lg mt-1">{c.course_title}</div>
                    <div className="text-sm text-slate-600 mt-1">Carga horária: {c.duration_hours}h · Emitido em {(c.issued_at || "").slice(0, 10)}</div>
                    <div className="text-xs font-mono mt-2 text-slate-500">Código: {c.code}</div>
                  </div>
                  <Award className="w-8 h-8 text-[var(--unigr-red)]" />
                </div>
                <div className="flex gap-2 mt-4">
                  <a href={`${API}/certificates/${c.code}/pdf`} target="_blank" rel="noopener noreferrer">
                    <Button className="btn-navy" data-testid={`download-cert-${c.code}`}><Download className="w-4 h-4 mr-2" />Baixar PDF</Button>
                  </a>
                  <a href={`/validate/${c.code}`} target="_blank" rel="noopener noreferrer">
                    <Button variant="outline" data-testid={`validate-cert-${c.code}`}><QrCode className="w-4 h-4 mr-2" />Validar online</Button>
                  </a>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
